// Состояние кнопок серверной шапки матч-центра (config.navigation.headers.matches): LIVE-фильтр и открытый календарь.
// Шапку рисует оболочка (AppBar), читает и меняет — экран матч-центра (HQ-269). startapp=live включает LIVE до первого
// кадра (маршрут /tab/matches?live=1).
import { useSyncExternalStore } from 'react';

export interface HeaderState {
  /** фильтр LIVE включён */
  liveOnly: boolean;
  /** поле строки матча, по которому фильтрует LIVE (action.field сервера: is_live / live_plausible) */
  liveField: string;
  /** открыт выбор даты */
  calendarOpen: boolean;
}

let state: HeaderState = { liveOnly: false, liveField: 'is_live', calendarOpen: false };
const listeners = new Set<() => void>();

export function getHeaderState(): HeaderState { return state; }
export function setHeaderState(patch: Partial<HeaderState>): void {
  state = { ...state, ...patch };
  listeners.forEach((l) => l());
}
export function useHeaderState(): HeaderState {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; }, getHeaderState);
}
